import {DEFAULT_CULTURE, FILTER_NAMES, ORDER, SORT_FIELDS} from '../base.js'
import {SECTION_PATHS} from '../common/paths.js'
import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  BODY_TYPE_4X4_ID,
  BODY_TYPE_CABRIO_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CATEGORY1_ID,
  DEFAULT_OFFER_TYPE_ID,
  OFFER_TYPE_DEMONSTRATION,
  OFFER_TYPE_KM0,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_NEW,
  OFFER_TYPE_SUBSTITUTION,
  SEGUNDA_MANO_CATEGORY1_ID,
  UNSELECTED_OFFER_TYPE,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './ads.js'
import {SELLER_TYPE_PRIVATE, SELLER_TYPE_PROFESSIONAL} from './dealer.js'
import {
  ADS_LIST_SEMANTIC_AUTOMATIC,
  ADS_LIST_SEMANTIC_BUSES,
  ADS_LIST_SEMANTIC_CAMPERVAN,
  ADS_LIST_SEMANTIC_CAR_TRAILER,
  ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE,
  ADS_LIST_SEMANTIC_CHEAP_VANS,
  ADS_LIST_SEMANTIC_CLASSIC_COMPETITION,
  ADS_LIST_SEMANTIC_COLOR,
  ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL,
  ADS_LIST_SEMANTIC_FINANCED,
  ADS_LIST_SEMANTIC_LIFESTYLE,
  ADS_LIST_SEMANTIC_MAX_PRICE,
  ADS_LIST_SEMANTIC_PRIVATE_SELLER,
  ADS_LIST_SEMANTIC_SEVEN_SEATS,
  ADS_LIST_SEMANTIC_TRACTORS,
  ADS_LIST_SEMANTIC_TRUCKS,
  ADS_LIST_SEMANTIC_VANS,
  ADS_LIST_SEMANTIC_YEAR,
  MODEL_DETAIL_INTERIOR_PAGE_NAME,
  MODEL_DETAIL_PAGE_NAME,
  MODEL_DETAIL_TRUNK_PAGE_NAME,
  MODEL_SIZES_PAGE_NAME
} from './page.js'
import {RENTING_CHEAP_PRICE, TARGET_BUYER} from './subscription.js'

export const NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS = 'NOINDEX, NOFOLLOW'

export const CRAWLABLE_AND_INDEXABLE_META_ROBOTS = 'INDEX, FOLLOW'

export const DEVELOPMENT_META_ROBOTS = NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS

export const META_ROBOTS_NO_INDEX_NO_FOLLOW = {content: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS, name: 'robots'}

export const HAS_STATIC_FAQS_ENABLED = true
export const HAS_RENTING_SEO_SLUG_INFO_ENABLED = true

export const STRUCTURED_DATA_VEHICLE_TYPE = 'Car'

export const SEMANTIC_KEYWORDS = {
  RENTING: {
    CHEAP: 'baratos',
    COMMITMENT_MONTHS: 'por-meses',
    COMMITMENT_MONTHS_NONE: 'sin-permanencia',
    COMMITMENT_MONTHS_12: '12-meses',
    COMMITMENT_MONTHS_24: '24-meses',
    COMMITMENT_MONTHS_36: '36-meses',
    COMMITMENT_MONTHS_48: '48-meses',
    VEHICLE_STATE_NEW: 'nuevo',
    VEHICLE_STATE_USED: 'segunda-mano',
    TARGET_BUYER_PRIVATE: 'particulares',
    TARGET_BUYER_BUSINESS: 'empresas',
    NO_ENTRY_FEE: 'sin-entrada',
    VEHICLE_TYPE_VAN: 'furgonetas'
  }
}

export const ADS_LIST_TITLES = {
  [SEGUNDA_MANO_CATEGORY1_ID]: {'es-ES': 'Coches'},
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    'es-ES': 'Furgonetas de segunda mano y vehículos industriales'
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    'es-ES': 'Autocaravanas, caravanas y remolques'
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {'es-ES': 'Coches sin carnet'},
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: {
    'es-ES': 'Coches clásicos y competición'
  }
}

/**
 * RENTING SEO KEYWORDS
 */
export const SEO_KEYWORDS = {
  CHEAP: 'baratos',
  NO_ENTRY_FEE: 'sin-entrada',
  NO_COMMITMENT: 'sin-permanencia',
  BY_MONTHS: 'por-meses',
  COMMITMENT_MONTHS: 'x-meses'
}

export const ACCEPTED_FAQS_PATHS = [
  '/renting',
  `/renting/${TARGET_BUYER.PRIVATES}`,
  `/renting/${SEMANTIC_KEYWORDS.RENTING.NO_ENTRY_FEE}`
]

export const SEO_KEYWORD_SLUG_REGEX = {
  COMMITMENTS_REGEX: /\/renting\/(12|24|36|48)-meses/
}

export const SEO_KEYWORD_SLUG_TO_KEYWORD_MAPPING = {
  [SEO_KEYWORDS.CHEAP]: 'baratos',
  [SEO_KEYWORDS.NO_ENTRY_FEE]: 'sin entrada',
  [SEO_KEYWORDS.NO_COMMITMENT]: 'sin permanencia',
  [SEO_KEYWORDS.BY_MONTHS]: 'por meses'
}

export const SEO_KEYWORDS_SLUG_TO_FILTER_OBJECT_MAPPER = {
  [SEO_KEYWORDS.CHEAP]: {
    fee: {from: undefined, to: RENTING_CHEAP_PRICE},
    [FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]: {
      from: undefined,
      to: RENTING_CHEAP_PRICE
    }
  },
  [SEO_KEYWORDS.NO_ENTRY_FEE]: {
    [FILTER_NAMES.SORT_BY]: SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE,
    sortOrder: ORDER.ASC
  },
  [SEO_KEYWORDS.NO_COMMITMENT]: {
    [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: [0]
  },
  [SEO_KEYWORDS.BY_MONTHS]: {
    [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: [12, 24, 36, 48]
  }
}

export const cheapLiteral = {
  'es-ES': 'baratos'
}

export const paginationLiteral = {
  'es-ES': 'Página'
}

export const locatedInLiteral = {
  'es-ES': 'en %{location}'
}

export const dealerWithMakeLiteral = {
  'es-ES': 'con %{make} en venta'
}

const NEWS_RSS_ALTERNATE = {
  TYPE: 'application/rss+xml',
  TITLE: 'coches.net Noticias (RSS)',
  URL: 'https://www.coches.net/noticias/rss/?maxrows=50'
}

export const SEO_RENTING_HARDCODED_SCHEMA_DATA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Renting coches.net',
    image: 'https://s.ccdn.es/images/coches/icons/logo-square-rounded-512x512.png',
    description:
      'Encuentra +3200 ofertas de renting y suscripción para particulares y empresas en el mayor portal de vehículos de España, Coches.net. Elige la marca y el modelo que más te guste y disfruta del coche de tus sueños al mejor precio.',
    aggregateRating: {
      '@type': 'AggregateRating',
      worstRating: 0,
      bestRating: 5,
      ratingValue: 4.9,
      ratingCount: 4092
    },
    offers: {
      '@type': 'Offer',
      price: '0.00',
      priceCurrency: 'EUR',
      seller: {'@type': 'Organization', name: 'coches.net', url: 'https://www.coches.net/'}
    }
  }
]

const adsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} %{fuelType} %{bodyType} %{cheap} de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} %{cheap} de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} %{bodyType} %{cheap} de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{type} %{fuelType} %{bodyType} al mejor precio %{toponym} por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListAllVehiclesDefaultMeta = {
  'es-ES': {
    CANONICAL: '',
    TITLE:
      '%{nResults} %{type} %{fuelType} %{bodyType} %{cheap} nuevos, de segunda mano y km0 %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} %{cheap} nuevos, de segunda mano y km0 %{toponym}',
    META_DESCRIPTION: '',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const adsListSemanticPrivateSellerDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} %{fuelType} de segunda mano y ocasión de particulares | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} de segunda mano y ocasión de particulares',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} de segunda mano y ocasión de propietarios particulares. ¡Encuentra %{type} %{fuelType} de particulares al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticVansDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas %{sellerType} de segunda mano %{toponym} | Coches.net',
    H1: 'Furgonetas %{sellerType} %{toponym}',
    META_DESCRIPTION: '%{nResults} Furgonetas %{sellerType} de segunda mano y ocasión. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticVansVersionMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas %{version} de segunda mano | Coches.net',
    H1: 'Furgonetas %{version}',
    META_DESCRIPTION: '%{nResults} Furgonetas %{version} de segunda mano y ocasión. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{make} %{model} %{fuelType} %{bodyType} de segunda mano y ocasión de particulares %{toponym} | Coches.net %{pagination}',
    H1: '%{make} %{model} %{fuelType} %{bodyType} de segunda mano y ocasión de particulares %{toponym}',

    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{fuelType} %{bodyType} de segunda mano y ocasión de propietarios particulares. ¡Encuentra %{make} %{model} %{fuelType} %{bodyType} de particulares al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{bodyType} de segunda mano y ocasión de particulares | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} de segunda mano y ocasión de particulares',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} de segunda mano y ocasión de propietarios particulares. ¡Encuentra %{bodyType} de particulares al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} %{fuelType} de segunda mano y ocasión de particulares %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} de segunda mano y ocasión de particulares %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} de segunda mano y ocasión de propietarios particulares %{toponym}. ¡Encuentra %{type} %{fuelType} de particulares %{toponym} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerBodyTypeProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{bodyType} de segunda mano y ocasión de particulares %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} de segunda mano y ocasión de particulares %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} de segunda mano y ocasión de propietarios particulares %{toponym}. ¡Encuentra %{bodyType} de particulares %{toponym}!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} de segunda mano y ocasión de 7 plazas | Coches.net %{pagination}',
    H1: '%{type} de segunda mano y ocasión de 7 plazas',
    META_DESCRIPTION:
      '%{nResults} %{type} con 7 plazas de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} de 7 plazas al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{make} %{model} %{fuelType} %{bodyType} 7 plazas de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{make} %{model} %{fuelType} %{bodyType} 7 plazas de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{fuelType} %{bodyType} 7 plazas de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{make} %{model} %{fuelType} %{bodyType} 7 plazas al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{bodyType} 7 plazas de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} 7 plazas de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} 7 plazas de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{bodyType} 7 plazas al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{fuelType} 7 plazas de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} 7 plazas de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} 7 plazas de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{type} %{fuelType} 7 plazas %{toponym} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsBodyTypeProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{bodyType} 7 plazas de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} 7 plazas de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} 7 plazas de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{bodyType} 7 plazas al mejor precio %{toponym}!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticSevenSeatsFuelTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{fuelType} 7 plazas de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} 7 plazas de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} 7 plazas de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} %{fuelType} 7 plazas al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} automáticos de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} automáticos de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{type} automáticos de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} automáticos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{make} %{model} %{fuelType} %{bodyType} automáticos de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{make} %{model} %{fuelType} %{bodyType} automáticos de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{fuelType} %{bodyType} automáticos de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{make} %{model} %{fuelType} %{bodyType} automáticos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{bodyType} automáticos de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} automáticos de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} automáticos de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{bodyType} automáticos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} %{fuelType} automáticos de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} automáticos de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} automáticos de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{type} %{fuelType} automáticos %{toponym} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticBodyTypeProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{bodyType} automáticos de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{bodyType} automáticos de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} automáticos de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{bodyType} automáticos al mejor precio %{toponym}!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticAutomaticFuelTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{fuelType} automáticos de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} automáticos de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} automáticos de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} %{fuelType} automáticos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticYearDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{make} %{model} año %{year} de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{make} %{model} año %{year} de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} año %{year} de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{make} %{model} año %{year} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticMaxPriceDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} de segunda mano hasta %{maxPrice} € | Coches.net',
    H1: '%{type} de segunda mano y ocasión por menos de %{maxPrice} euros',
    META_DESCRIPTION:
      '%{nResults} %{type} de particulares y concesionarios de segunda mano y ocasión hasta %{maxPrice} euros. ¡Encuentra %{type} usados por menos de %{maxPrice} €!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticMaxPriceProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} de segunda mano %{toponym} hasta %{maxPrice} € | Coches.net',
    H1: '%{type} de segunda mano y ocasión %{toponym} por menos de %{maxPrice} euros',
    META_DESCRIPTION:
      '%{nResults} %{type} de particulares y concesionarios de segunda mano y ocasión %{toponym} hasta %{maxPrice} euros. ¡Encuentra %{type} usados por menos de %{maxPrice} €!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticMaxPriceBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{bodyType} de segunda mano hasta %{maxPrice} € | Coches.net',
    H1: '%{type} %{bodyType} de segunda mano y ocasión por menos de %{maxPrice} euros',
    META_DESCRIPTION:
      '%{nResults} %{bodyType} de particulares y concesionarios de segunda mano y ocasión hasta %{maxPrice} euros. ¡Encuentra %{bodyType} por menos de %{maxPrice} €!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticMaxPriceFuelTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{fuelType} de segunda mano hasta %{maxPrice} € | Coches.net',
    H1: '%{type} %{fuelType} de segunda mano y ocasión por menos de %{maxPrice} euros',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} de particulares y concesionarios de segunda mano y ocasión hasta %{maxPrice} euros. ¡Encuentra %{type} %{fuelType} por menos de %{maxPrice} €!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCampervanDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas camper de segunda mano %{toponym} | Coches.net',
    H1: 'Furgonetas camper %{toponym}',
    META_DESCRIPTION:
      '%{nResults} Furgonetas camper de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCampervanVersionMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{version} de segunda mano %{toponym} | Coches.net',
    H1: '%{version} %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{version} de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCarTrailerDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Remolques de segunda mano | Coches.net',
    H1: 'Remolques',
    META_DESCRIPTION:
      '%{nResults} Remolques de segunda mano de todos los tipos: remolques para motos, de 750 kg, para mercancías y mucho más. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticFinancedDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches financiados de segunda mano | Coches.net',
    H1: 'Coches financiados de segunda mano',
    META_DESCRIPTION:
      'Explora %{nResults} coches de segunda mano financiados disponibles en coches.net. ¡Encuentra el coche ideal con opciones de financiación que se adapten a ti!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticFinancedWithoutEntryMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches financiados de segunda mano sin entrada | Coches.net',
    H1: 'Coches financiados sin entrada de segunda mano',
    META_DESCRIPTION:
      'Descubre %{nResults} coches de segunda mano con financiación sin entrada en coches.net. ¡Encuentra tu coche ideal sin necesidad de pago inicial!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticColorDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches de color %{color} de segunda mano y ocasión | Coches.net',
    H1: 'Coches de color %{color} de segunda mano y ocasión',
    META_DESCRIPTION:
      'Explora %{nResults} coches de color %{color}  de segunda mano y ocasión. ¡Encuentra y compra tu coche ideal al mejor precio en coches.net!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticColorMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{make} %{model} de color %{color} de segunda mano y ocasión | Coches.net',
    H1: '%{make} %{model} de color %{color} de segunda mano y ocasión',
    META_DESCRIPTION:
      'Descubre %{nResults} %{make} %{model} de color %{color} disponibles de segunda mano y ocasión. ¡Las mejores ofertas en coches están aquí!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCarsWithoutLicenseDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{type} de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{type} de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCarsWithoutLicenseMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{make} de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{make} de segunda mano y ocasión',
    META_DESCRIPTION:
      'Encuentra %{make} a la venta. Compara precios, fotos y equipamiento y compra tu %{make} ideal al mejor precio en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCarsWithoutLicenseMakeVersionMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{make} %{version} de segunda mano y ocasión | Coches.net %{pagination}',
    H1: '%{make} %{version} de segunda mano y ocasión',
    META_DESCRIPTION:
      'Encuentra %{make} %{version} a la venta. Compara precios, fotos y equipamiento y compra tu %{make} %{version} ideal al mejor precio en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticEnvironmentalLabelEcoMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches con Etiqueta ECO de segunda mano | coches.net',
    H1: 'Coches con Etiqueta ECO',
    META_DESCRIPTION:
      'Busca coches con etiqueta ECO de la DGT. Bajas emisiones, ventajas fiscales y acceso a ZBE. Compara los mejores anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticEnvironmentalLabelCeroMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches con Etiqueta 0 de segunda mano | coches.net',
    H1: 'Coches con Etiqueta 0',
    META_DESCRIPTION:
      'Encuentra coches de segunda mano con etiqueta 0 de la DGT. Acceso libre a Zonas de Bajas Emisiones sin restricciones. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticLifestyleFamiliasMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches para familias | coches.net',
    H1: 'Coches para familias',
    META_DESCRIPTION:
      'Encuentra coches para familias. Descubre la gran selección de vehículos que tenemos para tu estilo de vida. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticLifestyleCiudadMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches para ciudad | coches.net',
    H1: 'Coches para ciudad',
    META_DESCRIPTION:
      'Encuentra coches para ciudad. Descubre la gran selección de vehículos que tenemos para tu estilo de vida. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticLifestylePequenosMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches pequeños | coches.net',
    H1: 'Coches pequeños',
    META_DESCRIPTION:
      'Encuentra coches pequeños. Descubre la gran selección de vehículos que tenemos para tu estilo de vida. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticLifestyleBajasEmisionesMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Coches de bajas emisiones | coches.net',
    H1: 'Coches de bajas emisiones',
    META_DESCRIPTION:
      'Encuentra coches de bajas emisiones. Descubre la gran selección de vehículos que tenemos para tu estilo de vida. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticLifestylePrimerCocheMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Primer coche conductor novel | coches.net',
    H1: 'Primer coche conductor novel',
    META_DESCRIPTION:
      'Encuentra primer coche conductor novel. Descubre la gran selección de vehículos que tenemos para tu estilo de vida. Compara anuncios en coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{make} %{model} %{version} %{fuelType} %{bodyType} de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{make} %{model} %{version} %{fuelType} %{bodyType} al mejor precio %{toponym}!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListAllVehiclesMakeMeta = {
  'es-ES': {
    CANONICAL: '',
    TITLE:
      '%{nResults} %{type} %{make} %{model} %{version} %{fuelType} %{bodyType} nuevos, de segunda mano y km0 %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{make} %{model} %{version} %{fuelType} %{bodyType} nuevos, de segunda mano y km0 %{toponym}',
    META_DESCRIPTION: '',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const adsListBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{bodyType} %{cheap} de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} %{cheap} de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{fuelType} %{bodyType} %{cheap} de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{bodyType} al mejor precio %{toponym} por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListVersionMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} con %{version} de segunda mano y ocasión | Coches.net',
    H1: '%{type} con %{version}',
    META_DESCRIPTION:
      '%{nResults} %{type} con %{version} de particulares y concesionarios de segunda mano y ocasión. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListAllVehiclesBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '',
    TITLE:
      '%{nResults} %{type} %{bodyType} %{cheap} nuevos, de segunda mano y km0 %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} %{cheap} nuevos, de segunda mano y km0 %{toponym}',
    META_DESCRIPTION: '',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const adsListNewVehicleDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{fuelType} %{bodyType} Nuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} nuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} %{bodyType} nuevos %{toponym} de concesionarios. ¡Encuentra %{type} %{fuelType} %{bodyType} nuevos %{toponym} al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListNewVehicleMakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} Nuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{make} %{model} %{version} %{fuelType} %{bodyType} nuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} nuevos %{toponym} de concesionarios. ¡Encuentra %{make} %{model} %{version} %{fuelType} %{bodyType} nuevos %{toponym} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListNewVehicleBodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{bodyType} Nuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} nuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} %{bodyType} nuevos de concesionarios. ¡Encuentra %{type} %{bodyType} nuevos %{toponym} al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListNewVehicleSemanticMaxPriceDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} nuevos por %{maxPrice} € | Coches.net',
    H1: '%{type} nuevos por %{maxPrice} euros',
    META_DESCRIPTION:
      '%{nResults} %{type} nuevos por %{maxPrice} euros de concesionarios. ¡Encuentra %{type} nuevos al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListNewVehicleCheapSemanticDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} nuevos baratos | Coches.net',
    H1: '%{type} nuevos baratos',
    META_DESCRIPTION:
      '%{nResults} %{type} nuevos baratos de concesionarios. ¡Encuentra Coches nuevos baratos al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListKm0DefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{fuelType} %{bodyType} de km0 y seminuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} de km0 y seminuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} %{bodyType} de particulares y concesionarios de km0 y seminuevos %{toponym}. ¡Encuentra %{type} %{fuelType} %{bodyType} al mejor precio %{toponym} por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListKm0MakeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} de km0 y seminuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{make} %{model} %{version} %{fuelType} %{bodyType} de km0 y seminuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{make} %{model} %{version} %{fuelType} %{bodyType} de particulares y concesionarios de km0 y seminuevos %{toponym}. ¡Encuentra %{make} %{model} %{version} %{fuelType} %{bodyType} al mejor precio %{toponym}!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListKm0BodyTypeMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{bodyType} de km0 y seminuevos %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{fuelType} %{bodyType} de km0 y seminuevos %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{fuelType} %{bodyType} de particulares y concesionarios de km0 y seminuevos %{toponym}. ¡Encuentra %{bodyType} al mejor precio %{toponym} por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListMeta = {
  [DEFAULT_OFFER_TYPE_ID]: {
    default: adsListDefaultMeta,
    make: adsListMakeMeta,
    bodyType: adsListBodyTypeMeta,
    version: adsListVersionMeta,
    semanticPrivateSellerDefault: adsListSemanticPrivateSellerDefaultMeta,
    semanticPrivateSellerMake: adsListSemanticPrivateSellerMakeMeta,
    semanticPrivateSellerBodyType: adsListSemanticPrivateSellerBodyTypeMeta,
    semanticPrivateSellerProvince: adsListSemanticPrivateSellerProvinceMeta,
    semanticPrivateSellerBodyTypeProvince: adsListSemanticPrivateSellerBodyTypeProvinceMeta,
    semanticSevenSeatsDefault: adsListSemanticSevenSeatsDefaultMeta,
    semanticSevenSeatsMake: adsListSemanticSevenSeatsMakeMeta,
    semanticSevenSeatsBodyType: adsListSemanticSevenSeatsBodyTypeMeta,
    semanticSevenSeatsProvince: adsListSemanticSevenSeatsProvinceMeta,
    semanticSevenSeatsBodyTypeProvince: adsListSemanticSevenSeatsBodyTypeProvinceMeta,
    semanticSevenSeatsFuelType: adsListSemanticSevenSeatsFuelTypeMeta,
    semanticAutomaticDefault: adsListSemanticAutomaticDefaultMeta,
    semanticAutomaticMake: adsListSemanticAutomaticMakeMeta,
    semanticAutomaticBodyType: adsListSemanticAutomaticBodyTypeMeta,
    semanticAutomaticProvince: adsListSemanticAutomaticProvinceMeta,
    semanticAutomaticBodyTypeProvince: adsListSemanticAutomaticBodyTypeProvinceMeta,
    semanticAutomaticFuelType: adsListSemanticAutomaticFuelTypeMeta,
    semanticYearDefault: adsListSemanticYearDefaultMeta,
    semanticMaxPriceDefault: adsListSemanticMaxPriceDefaultMeta,
    semanticMaxPriceProvince: adsListSemanticMaxPriceProvinceMeta,
    semanticMaxPriceBodyType: adsListSemanticMaxPriceBodyTypeMeta,
    semanticMaxPriceFuelType: adsListSemanticMaxPriceFuelTypeMeta,
    semanticFinancedDefault: adsListSemanticFinancedDefaultMeta,
    semanticFinancedWithoutEntry: adsListSemanticFinancedWithoutEntryMeta,
    semanticColorDefault: adsListSemanticColorDefaultMeta,
    semanticColorMake: adsListSemanticColorMakeMeta,
    semanticCarsWithoutLicenseDefault: adsListSemanticCarsWithoutLicenseDefaultMeta,
    semanticCarsWithoutLicenseMake: adsListSemanticCarsWithoutLicenseMakeMeta,
    semanticCarsWithoutLicenseMakeVersion: adsListSemanticCarsWithoutLicenseMakeVersionMeta,
    semanticEnvironmentalLabelEco: adsListSemanticEnvironmentalLabelEcoMeta,
    semanticEnvironmentalLabelCero: adsListSemanticEnvironmentalLabelCeroMeta,
    semanticLifestyleFamilias: adsListSemanticLifestyleFamiliasMeta,
    semanticLifestyleCiudad: adsListSemanticLifestyleCiudadMeta,
    semanticLifestylePequenos: adsListSemanticLifestylePequenosMeta,
    semanticLifestyleBajasEmisiones: adsListSemanticLifestyleBajasEmisionesMeta,
    semanticLifestylePrimerCoche: adsListSemanticLifestylePrimerCocheMeta
  },
  [OFFER_TYPE_KM0]: {
    default: adsListKm0DefaultMeta,
    make: adsListKm0MakeMeta,
    bodyType: adsListKm0BodyTypeMeta
  },
  [OFFER_TYPE_NEW]: {
    default: adsListNewVehicleDefaultMeta,
    make: adsListNewVehicleMakeMeta,
    bodyType: adsListNewVehicleBodyTypeMeta,
    cheap_new: adsListNewVehicleCheapSemanticDefaultMeta,
    semanticMaxPriceDefault: adsListNewVehicleSemanticMaxPriceDefaultMeta
  },
  [OFFER_TYPE_SUBSTITUTION]: {
    default: adsListKm0DefaultMeta
  },
  [OFFER_TYPE_MANAGEMENT]: {
    default: adsListKm0DefaultMeta
  },
  [OFFER_TYPE_DEMONSTRATION]: {
    default: adsListKm0DefaultMeta
  },
  [UNSELECTED_OFFER_TYPE]: {
    default: adsListAllVehiclesDefaultMeta,
    make: adsListAllVehiclesMakeMeta,
    bodyType: adsListAllVehiclesBodyTypeMeta
  }
}

export const adsListSemanticMapper = {
  [ADS_LIST_SEMANTIC_VANS]: {
    default: 'semanticVansDefault',
    version: 'semanticVansVersion'
  },
  [ADS_LIST_SEMANTIC_PRIVATE_SELLER]: {
    default: 'semanticPrivateSellerDefault',
    make: 'semanticPrivateSellerMake',
    bodyType: 'semanticPrivateSellerBodyType',
    province: 'semanticPrivateSellerProvince',
    bopyTypeProvince: 'semanticPrivateSellerBodyTypeProvince'
  },
  [ADS_LIST_SEMANTIC_SEVEN_SEATS]: {
    default: 'semanticSevenSeatsDefault',
    make: 'semanticSevenSeatsMake',
    bodyType: 'semanticSevenSeatsBodyType',
    province: 'semanticSevenSeatsProvince',
    bodyTypeProvince: 'semanticSevenSeatsBodyTypeProvince',
    fuelType: 'semanticSevenSeatsFuelType'
  },
  [ADS_LIST_SEMANTIC_AUTOMATIC]: {
    default: 'semanticAutomaticDefault',
    make: 'semanticAutomaticMake',
    bodyType: 'semanticAutomaticBodyType',
    province: 'semanticAutomaticProvince',
    bodyTypeProvince: 'semanticAutomaticBodyTypeProvince',
    fuelType: 'semanticAutomaticFuelType'
  },
  [ADS_LIST_SEMANTIC_YEAR]: {
    default: 'semanticYearDefault'
  },
  [ADS_LIST_SEMANTIC_MAX_PRICE]: {
    default: 'semanticMaxPriceDefault',
    province: 'semanticMaxPriceProvince',
    bodyType: 'semanticMaxPriceBodyType',
    fuelType: 'semanticMaxPriceFuelType'
  },
  [ADS_LIST_SEMANTIC_CAMPERVAN]: {
    default: 'semanticCampervanDefault',
    version: 'semanticCampervanVersion'
  },
  [ADS_LIST_SEMANTIC_CAR_TRAILER]: {
    default: 'semanticCarTrailerDefault'
  },
  [ADS_LIST_SEMANTIC_CHEAP_VANS]: {
    default: 'semanticCheapVansDefault'
  },
  [ADS_LIST_SEMANTIC_CLASSIC_COMPETITION]: {
    default: 'semanticClassicCompetitionDefault'
  },
  [ADS_LIST_SEMANTIC_TRACTORS]: {
    default: 'semanticTractorsDefault'
  },
  [ADS_LIST_SEMANTIC_TRUCKS]: {
    default: 'semanticTrucksDefault'
  },
  [ADS_LIST_SEMANTIC_BUSES]: {
    default: 'semanticBusesDefault'
  },
  [ADS_LIST_SEMANTIC_FINANCED]: {
    default: 'semanticFinancedDefault',
    withoutEntry: 'semanticFinancedWithoutEntry'
  },
  [ADS_LIST_SEMANTIC_COLOR]: {
    default: 'semanticColorDefault',
    make: 'semanticColorMake'
  },
  [ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE]: {
    default: 'semanticCarsWithoutLicenseDefault',
    make: 'semanticCarsWithoutLicenseMake',
    'make-version': 'semanticCarsWithoutLicenseMakeVersion'
  },
  [ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL]: {
    eco: 'semanticEnvironmentalLabelEco',
    cero: 'semanticEnvironmentalLabelCero'
  },
  [ADS_LIST_SEMANTIC_LIFESTYLE]: {
    familias: 'semanticLifestyleFamilias',
    ciudad: 'semanticLifestyleCiudad',
    pequenos: 'semanticLifestylePequenos',
    bajasEmisiones: 'semanticLifestyleBajasEmisiones',
    primerCoche: 'semanticLifestylePrimerCoche'
  }
}

const classicsAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{version} %{fuelType} en venta de ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{version} %{fuelType} %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{version} %{fuelType} en venta de segunda mano y ocasión. ¡Encuentra %{type} %{fuelType} %{bodyType} en venta al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const classicsAdsListMakeModelMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{version} %{type} %{fuelType} %{toponym} de segunda mano | Coches.net',
    H1: '%{version} %{type} %{fuelType} %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{version} %{type} en venta de segunda mano y ocasión. ¡Encuentra %{version} clásicos antiguos y de competición en venta al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const classicsAdsListMeta = {
  [DEFAULT_OFFER_TYPE_ID]: {
    default: classicsAdsListDefaultMeta,
    semanticClassicCompetitionDefault: classicsAdsListMakeModelMeta
  }
}

const commercialAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{version} %{fuelType} de ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{version} %{fuelType} de ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{fuelType} de particulares y concesionarios de ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialAdsListMakeModelMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      'Furgonetas %{make} %{model} %{fuelType} de segunda mano y vehículos industriales de ocasión %{toponym} | Coches.net',
    H1: 'Furgonetas %{make} %{model} %{fuelType} de segunda mano %{toponym}',
    META_DESCRIPTION:
      '%{nResults} Furgonetas %{make} %{model} %{fuelType} de segunda mano y vehículos industriales de particulares y concesionarios de ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialAdsListSeatsMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas de %{seats} plazas de segunda mano | Coches.net',
    H1: 'Furgonetas de %{seats} plazas',
    META_DESCRIPTION:
      '%{nResults} Furgonetas de %{seats} plazas de particulares y concesionarios de segunda mano y ocasión. ¡Encuéntralas al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialAdsListVersionMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas %{version} de segunda mano | Coches.net',
    H1: 'Furgonetas %{version}',
    META_DESCRIPTION: '%{nResults} Furgonetas %{version} de segunda mano y ocasión. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialTrucksAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Camiones de segunda mano %{toponym} | Coches.net',
    H1: 'Camiones de segunda mano %{toponym}',
    META_DESCRIPTION:
      '%{nResults} Camiones de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialTractorsAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Tractores de segunda mano usados | Coches.net',
    H1: 'Tractores de segunda mano usados',
    META_DESCRIPTION: 'Encuentra %{nResults} tractores de segunda mano usados en Coches.net.',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialBusesAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Autobuses de segunda mano %{toponym} | Coches.net',
    H1: 'Autobuses de segunda mano %{toponym}',
    META_DESCRIPTION:
      '%{nResults} Autobuses de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticCheapVansDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Furgonetas baratas de segunda mano | Coches.net',
    H1: 'Furgonetas baratas de segunda mano',
    META_DESCRIPTION:
      '%{nResults} Furgonetas baratas de segunda mano de particulares y concesionarios de ocasión. ¡Encuéntralas al precio más bajo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const commercialAdsListMeta = {
  [DEFAULT_OFFER_TYPE_ID]: {
    default: commercialAdsListDefaultMeta,
    makeModel: commercialAdsListMakeModelMeta,
    seats: commercialAdsListSeatsMeta,
    version: commercialAdsListVersionMeta,
    semanticVansDefault: adsListSemanticVansDefaultMeta,
    semanticVansVersion: adsListSemanticVansVersionMeta,
    semanticCheapVansDefault: adsListSemanticCheapVansDefaultMeta,
    semanticTractorsDefault: commercialTractorsAdsListDefaultMeta,
    semanticTrucksDefault: commercialTrucksAdsListDefaultMeta,
    semanticBusesDefault: commercialBusesAdsListDefaultMeta
  }
}

const autocaravansAdsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{version} de segunda mano %{toponym} | Coches.net %{pagination}',
    H1: '%{type} %{version} %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{version} de particulares y concesionarios de segunda mano y ocasión. ¡Encuentra %{type} al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const autocaravansAdsListCategory2Meta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{category2} %{version} de segunda mano y ocasión %{toponym} | Coches.net %{pagination}',
    H1: '%{category2} %{version} %{toponym}',
    META_DESCRIPTION: '%{nResults} %{category2} %{version} de segunda mano y ocasión. ¡Encuéntralos al mejor precio!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const autocaravansAdsListMeta = {
  [DEFAULT_OFFER_TYPE_ID]: {
    default: autocaravansAdsListDefaultMeta,
    category2: autocaravansAdsListCategory2Meta,
    semanticCampervanDefault: adsListSemanticCampervanDefaultMeta,
    semanticCampervanVersion: adsListSemanticCampervanVersionMeta,
    semanticCarTrailerDefault: adsListSemanticCarTrailerDefaultMeta
  }
}

export const adsListMetaMapper = {
  [SEGUNDA_MANO_CATEGORY1_ID]: adsListMeta,
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: commercialAdsListMeta,
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: autocaravansAdsListMeta,
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: adsListMeta,
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: classicsAdsListMeta
}

export const subscriptionAdsList = {
  'es-ES': {
    TITLE: 'Coches.net renting y suscripción desde %{minPrice} euros al mes',
    H1: '%{nResults} coches %{fuelType} %{bodyType} de renting y suscripción',
    META_DESCRIPTION:
      'Encuentra %{nResults} ofertas de renting y suscripción para particulares y empresas en el mayor portal de vehículos de España, Coches.net. Elige la marca y el modelo que más te guste y disfruta del coche de tus sueños al mejor precio.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListBodyTypeMeta = {
  'es-ES': {
    TITLE: 'Renting de %{make}%{space}%{bodyType} | Coches.net',
    H1: '%{nResults} %{make}%{space}%{bodyType} de renting y suscripción',
    META_DESCRIPTION:
      '%{nResults} ofertas de %{make}%{space}%{bodyType} de renting y suscripción para particulares y empresas. Disfruta de tu %{make}%{space}%{bodyType} de renting sin necesidad de comprarla y al mejor precio.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListFuelTypeMeta = {
  'es-ES': {
    TITLE: 'Renting coche %{fuelType} | Coches.net',
    H1: '%{nResults} Renting %{fuelType}',
    META_DESCRIPTION:
      '%{nResults} coches %{fuelType} de renting y suscripción para particulares y empresas. Disfruta del coche de tus sueños sin necesidad de comprarlo y al mejor precio.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListFuelTypeMakeMeta = {
  'es-ES': {
    TITLE: 'Renting %{make} %{fuelType} desde %{minPrice} euros al mes | Coches.net',
    H1: '%{nResults} Renting %{make} %{fuelType}',
    META_DESCRIPTION:
      '%{nResults} %{make} %{fuelType} de renting y suscripción para particulares y empresas. Disfruta del coche de tus sueños sin necesidad de comprarlo y al mejor precio.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListMakeMeta = {
  'es-ES': {
    TITLE: 'Renting %{make} desde %{minPrice} euros al mes | Coches.net',
    H1: '%{make} %{fuelType} %{bodyType} de renting y suscripción',
    META_DESCRIPTION:
      'Descubre %{nResults} %{make} de renting y suscripción para particulares y empresas en el mayor portal de vehículos de España, Coches.net. Elige el %{make} que más te guste y disfruta del coche de tus sueños con las mejores condiciones.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListMakeModelMeta = {
  'es-ES': {
    TITLE: 'Renting %{make} %{model} - Todos nuestros %{make} %{model} de renting y suscripción | Coches.net',
    H1: '%{make} %{model} %{fuelType} %{bodyType} de renting y suscripción',
    META_DESCRIPTION:
      'Descubre %{nResults} %{make} %{model} de renting y suscripción para particulares y empresas en el mayor portal de vehículos de España, Coches.net. Elige el %{make} %{model} que más te guste y disfruta del coche de tus sueños con las mejores condiciones.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListVehicleStateMeta = {
  'es-ES': {
    TITLE: 'Renting de coches %{vehicleState} | Coches.net',
    H1: '%{nResults} coches de renting %{vehicleState}',
    META_DESCRIPTION:
      '%{nResults} ofertas de renting y suscripción de coches %{vehicleState} para particulares. Disfruta de tu coche de renting ideal a un precio más económico.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListVehicleStateUsedMeta = {
  'es-ES': {
    TITLE: 'Renting de segunda mano y seminuevos | Coches.net',
    H1: '%{nResults} coches de renting de segunda mano',
    META_DESCRIPTION:
      '%{nResults} ofertas de renting de segunda mano y suscripción de seminuevos para particulares. Disfruta de tu coche de renting ideal a un precio más económico.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListVehicleStateNewMeta = {
  'es-ES': {
    TITLE: 'Coches.net Renting de coches nuevos',
    H1: '%{nResults} coches de renting nuevos',
    META_DESCRIPTION:
      '%{nResults} ofertas de renting y suscripción de coches nuevos para particulares. Disfruta de tu coche de renting ideal a un precio más económico.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListSemanticTargetBuyerMeta = {
  [SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_PRIVATE]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting para particulares | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting para particulares',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción para particulares. Disfruta de tu coche de renting ideal para particulares sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  [SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_BUSINESS]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting para empresas | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting para empresas',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción para empresas. Disfruta de tu coche de renting ideal para empresas sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const subscriptionAdsListSemanticVehicleVanTypeMeta = {
  [DEFAULT_CULTURE]: {
    CANONICAL: '%{canonical}',
    TITLE: 'Renting de furgonetas | %{nResults} ofertas | Coches.net',
    H1: '%{nResults} furgonetas de renting',
    META_DESCRIPTION:
      '%{nResults} ofertas de furgonetas de renting y suscripción. Disfruta de tu furgoneta de renting sin necesidad de comprarla y al mejor precio.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListSemanticKeywordMeta = {
  [SEMANTIC_KEYWORDS.RENTING.CHEAP]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting de coches baratos | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting baratos',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción baratos. Disfruta de tu coche de renting barato sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  [SEMANTIC_KEYWORDS.RENTING.NO_ENTRY_FEE]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting sin entrada | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting sin entrada',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción sin entrada. Disfruta de tu coche de renting sin entrada, sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  [SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_NONE]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting sin permanencia | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting sin permanencia',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción sin permanencia. Disfruta de tu coche de renting sin permanencia, sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  [SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting por meses | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} coches de renting por meses',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting y suscripción por meses. Disfruta de tu coche de renting por meses, sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const subscriptionAdsListSemanticCommitmentMonthsMeta = {
  [DEFAULT_CULTURE]: {
    CANONICAL: '%{canonical}',
    TITLE: 'Renting %{commitmentMonths} meses | %{nResults} ofertas | Coches.net',
    H1: '%{nResults} coches de renting - %{commitmentMonths} meses',
    META_DESCRIPTION:
      '%{nResults} ofertas de renting y suscripción de %{commitmentMonths} meses. Disfruta de tu coche ideal por el tiempo que necesites.',
    META_ROBOTS: '%{metaRobots}'
  }
}

export const subscriptionAdsListSemanticKeywordMakeMeta = {
  [SEMANTIC_KEYWORDS.RENTING.NO_ENTRY_FEE]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting %{make} sin entrada | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} %{make} renting sin entrada',
      META_DESCRIPTION:
        '%{nResults} %{make} de renting y suscripción sin entrada. Disfruta de tu %{make} de renting sin entrada, sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const subscriptionAdsListSemanticTargetBuyerMakeMeta = {
  [SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_PRIVATE]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting %{make} para %{targetBuyer} | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} %{make} renting para %{targetBuyer}',
      META_DESCRIPTION:
        '%{nResults} %{make} de renting y suscripción para %{targetBuyer}. Disfruta de tu %{make} de renting ideal para %{targetBuyer} sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  [SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_BUSINESS]: {
    [DEFAULT_CULTURE]: {
      CANONICAL: '%{canonical}',
      TITLE: 'Renting %{make} para empresas y autónomos | %{nResults} ofertas | Coches.net',
      H1: '%{nResults} %{make} renting para empresas y autónomos',
      META_DESCRIPTION:
        '%{nResults} %{make} de renting y suscripción para empresas y autónomos. Disfruta de tu %{make} de renting ideal para empresas y autónomos sin necesidad de comprarlo y al mejor precio.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const dealersList = {
  default: {
    'es-ES': {
      TITLE: 'Todos los concesionarios de coches en España | Coches.net',
      H1: 'Concesionarios de coches en España',
      META_DESCRIPTION:
        'En coches.net tenemos los coches de los mejores concesionarios de España, en todas las provincias. ¡Entra y descubre los más cercanos!',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  filtered: {
    'es-ES': {
      TITLE: 'Concesionarios de coches %{make} %{toponym} | Coches.net',
      H1: 'Concesionarios %{dealerMake} %{toponym}',
      META_DESCRIPTION:
        '¿Buscas un concesionario de coches %{make} %{toponym}? En coches.net puedes consultar online todos los vehículos de concesionarios %{make} %{toponym}.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const insurance = {
  'es-ES': {
    CANONICAL: '',
    TITLE: 'Seguro coches',
    META_DESCRIPTION:
      'Compara entre los seguros de coches con las mejores condiciones y ahorra dinero. Encuentra y asegura fácilmente tu vehículo gracias a Coches.net.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const professionalStock = {
  'es-ES': {
    default: {
      TITLE: '%{name} - Concesionario en %{province} | Coches.net',
      META_DESCRIPTION:
        'Todos los vehículos del concesionario %{name} en %{province}. Descubre todas las ofertas de este concesionario en coches.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    [SECTION_PATHS.INFORMATION]: {
      TITLE: '%{name} Teléfono, Dirección, Horarios y más información | Coches.net',
      H1: '%{name} Teléfono, Dirección, Horarios y más información',
      META_DESCRIPTION:
        'Teléfono, Dirección, Horarios y más información de %{name}. Encuentra todo lo que necesitas saber para ponerte en contacto o visitar a %{name}.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    [SECTION_PATHS.RATINGS]: {
      TITLE: '%{name} Opiniones - %{totalReviews} reseñas y experiencias | Coches.net',
      H1: '%{name} Opiniones y reseñas',
      META_DESCRIPTION: 'Lee las opiniones y reseñas de clientes anteriores sobre %{name}.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const professionalRentingStock = {
  'es-ES': {
    default: {
      TITLE: '%{name} Renting - %{nResults} ofertas de renting | Coches.net',
      H1: '%{name} Renting',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting de %{name}. Descubre todas las ofertas de renting de %{name} en coches.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    [SECTION_PATHS.RENTING_BUSINESS]: {
      TITLE: '%{name} Renting - %{nResults} ofertas de renting para empresas | Coches.net',
      H1: '%{name} Renting para empresas',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting para empresas de %{name}. Descubre todas las ofertas de renting para empresas de %{name} en coches.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    [SECTION_PATHS.INFORMATION]: {
      TITLE: '%{name} Renting Teléfono, Dirección, Horarios y más información | Coches.net',
      H1: '%{name} Renting Teléfono, Dirección, Horarios y más información',
      META_DESCRIPTION:
        'Teléfono, Dirección, Horarios y más información de %{name}. Encuentra todo lo que necesitas saber para ponerte en contacto o visitar a %{name} Renting.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const home = {
  'es-ES': {
    CANONICAL: '',
    TITLE: 'Coches.net: Coches nuevos, coches de ocasión, seminuevos, Km0',
    META_DESCRIPTION:
      'La mejor oferta de coches de km0 y segunda mano en España: sea cual sea tu estilo de vida, tenemos un coche para ti. Coches nuevos, de segunda mano, y Km0, noticias de motor, videos y foros de coches. Compara las mejores ofertas y contacta con particulares y concesionarios. ¡Tu próximo coche está aquí!',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const staticSections = {
  login: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Login - Acceso de Usuario',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-discounts': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Coches.net Club',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'user-favorite-ads': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis favoritos | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-profile': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mi cuenta | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-profile-edit': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Editar mis datos personales | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-saved-searches': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis búsquedas | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'user-alerts-matches': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Nuevos anuncios para mis alertas | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'terms-of-service': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Condiciones generales de uso de Coches.net',
      META_DESCRIPTION: 'Condiciones generales de uso de Coches.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  transparency: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Transparencia de Coches.net',
      META_DESCRIPTION: 'Transparencia de Coches.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'terms-of-service-reservation': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Condiciones de uso de del servicio de reserva de Coches.net',
      META_DESCRIPTION: 'Condiciones de uso de del servicio de reserva de Coches.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'other-partners': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Política de cookies Coches.net - entidades terceras',
      META_DESCRIPTION: 'Política de cookies Coches.net - entidades terceras',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  checkout: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago seguro | Coches.net',
      META_DESCRIPTION: 'Formulario de pagos de Coches.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'checkout-success': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago realizado | Coches.net',
      META_DESCRIPTION: 'Pago realizado correctamente',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago no realizado | Coches.net',
      META_DESCRIPTION: 'Pago no realizado, ha habido problemas para realizar tu pago',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-pending': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Compra en cola | Coches.net',
      META_DESCRIPTION: 'Compra en cola, te enviaremos un email cuando tu compra se acabe de procesar',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-activation-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No hemos podido activar tu producto | Coches.net',
      META_DESCRIPTION: 'No hemos podido activar tu producto, recibirás el reembolso de tu pago en los próximos días',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-request-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No se puede completar la compra | Coches.net',
      META_DESCRIPTION: 'El producto que estás intentando comprar no existe o no puede ser activado para este anuncio',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-refund-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No hemos podido activar tu compra | Coches.net',
      META_DESCRIPTION: 'Ha habido un problema con la activación de tu compra',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-unknown-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Error desconocido | Coches.net',
      META_DESCRIPTION:
        'Ha habido un error desconocido con tu compra, por favor contacta con nuestro equipo de soporte',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  comparador: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Comparador de coches | Coches.net',
      META_DESCRIPTION: 'Te ayudamos a elegir el coche para ti. Compara prestaciones y precios.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  net_assistant: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Net: el buscador de coches con IA | Coches.net',
      META_DESCRIPTION:
        'Olvídate de marcas y filtros. Cuéntale a Net lo que buscas y la IA de coches.net encuentra tu coche ideal entre miles de anuncios. Pruébalo, es gratis.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  products: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Dale más visibilidad a tu anuncio | Coches.net',
      META_DESCRIPTION: 'Listado de productos de visibilidad',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'payment-ad-request': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Publica tu anuncio de pago | Coches.net',
      META_DESCRIPTION: 'Ya has llegado al límite de anuncios gratuitos',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  professionals: {
    'es-ES': {
      CANONICAL: '/registro-profesionales/',
      TITLE: 'Anúnciate como concesionario | Coches.net',
      H1: 'Anúnciate como concesionario para vender más coches y mejor',
      META_DESCRIPTION:
        'Pon tus vehículos al alcance de millones de usuarios, donde más compradores los verán. Descubre las ventajas de nuestros productos para profesionales.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'ad-management-my-ads': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis anuncios | Coches.net',
      META_DESCRIPTION: '',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  }
}

export const publishMyAd = {
  'es-ES': {
    CANONICAL: '/publicar-mi-anuncio/',
    H1: 'Publica tu coche en coches.net',
    TITLE: 'Vende tu coche rápido y al mejor precio en coches.net',
    META_DESCRIPTION:
      'Vende tu coche de manera rápida y sencilla en Coches.net. Obtén una tasación gratuita online, publica tu anuncio fácilmente y conecta con miles de compradores interesados. ¡Vende tu coche hoy mismo y consigue el mejor precio!',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const editMyAd = {
  'es-ES': {
    CANONICAL: '/editar-mi-anuncio/',
    H1: 'Edita tu anuncio en coches.net',
    TITLE: 'Edita tu anuncio en coches.net',
    META_DESCRIPTION: 'Edita tu anuncio en coches.net',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const publishYourAd = {
  'es-ES': {
    H1: 'Vende tu coche online fácil y rápido',
    TITLE: 'Vende tu coche rápido y al mejor precio en coches.net',
    META_DESCRIPTION:
      'Vende tu coche de manera rápida y sencilla en Coches.net. Obtén una tasación gratuita online, publica tu anuncio fácilmente y conecta con miles de compradores interesados. ¡Vende tu coche hoy mismo y consigue el mejor precio!',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const publishYourAdWithLocation = {
  'es-ES': {
    TITLE: 'Vende tu coche en %{location} desde coches.net rápido y al mejor precio',
    H1: 'Vende tu coche en %{location} fácil y rápido',
    META_DESCRIPTION:
      'Vender tu coche en %{location} es más sencillo que nunca. En coches.net te ofrecemos la mejor plataforma para vender tu coche en %{location} al mejor precio ya sea a profesionales o particulares.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const publishYourAdWithPlate = {
  'es-ES': {
    H1: 'Introduce la matrícula para encontrar tu coche',
    TITLE: 'Vende tu coche rápido y al mejor precio en coches.net | Introduce la matrícula para encontrar tu coche.',
    META_DESCRIPTION:
      '¿Pensando en vender tu coche? Introduce la matrícula para encontrar tu coche, para que puedas anunciarlo en Coches.net y aprovechar la visibilidad del mayor portal de venta online. ¡Publica tu anuncio gratis ahora!',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const publishMyAdCategory = {
  'es-ES': {
    H1: 'Elige el tipo de vehículo',
    TITLE: 'Vende tu coche rápido y al mejor precio en coches.net | Elige el tipo de vehículo',
    META_DESCRIPTION:
      '¿Pensando en vender tu coche? Elige el tipo de vehículo, para que puedas anunciarlo en Coches.net y aprovechar la visibilidad del mayor portal de venta online. ¡Publica tu anuncio gratis ahora!',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const news = {
  'news-category': {
    portada: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/?pg=%{page}',
        TITLE: 'Noticias de coches y actualidad del mundo del motor | Coches.net',
        H1: 'Últimas noticias de coches y actualidad en motor',
        META_DESCRIPTION:
          'Ponte al día con las últimas noticias de coches y la actualidad del mundo del motor. Consulta nuestras pruebas de los últimos modelos del mercado, novedades y videos de la mano de los expertos de coches.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    pruebas: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/pruebas/?pg=%{page}',
        TITLE: 'Pruebas de coches y valoración de últimos modelos | Coches.net',
        H1: 'Pruebas de coches',
        META_DESCRIPTION:
          'Pruebas y Vídeopruebas. Conoce las opiniones y impresiones de los últimos modelos de coches de todas las marcas. En coches.net, nuestros expertos del motor se ponen al volante para traerte toda la información sobre los modelos de coches más buscados.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    novedades: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/novedades/?pg=%{page}',
        TITLE: 'Novedades de coches y próximos modelos de marcas  | Coches.net',
        H1: 'Novedades de coches y últimos modelos por marca',
        META_DESCRIPTION:
          'Descubre todas las novedades de coches en el mercado. Los últimos modelos de coches y próximos lanzamientos de todas las marcas, analizados por nuestros expertos del motor.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    comparativas: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/comparativas/?pg=%{page}',
        TITLE: 'Comparativa de coches | Coches.net',
        H1: 'Comparativa de coches',
        META_DESCRIPTION:
          'Nuestros expertos analizan y comparan para ti los coches de marcas y modelos más buscados en España. En coches.net te ayudamos con comparativas detalladas para que puedas elegir tu nuevo coche con total tranquilidad.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    videos: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/videos/?pg=%{page}',
        TITLE: 'Vídeos de coches, pruebas, comparativas y actualidad motor | Coches.net',
        H1: 'Vídeos de coches',
        META_DESCRIPTION:
          'Encuentra todos los vídeos de nuestros expertos del mundo del motor, con vídeopruebas de los modelos de coches más buscados, los eventos más destacados, reportages y presentaciones en exclusiva para estar al día de todas las novedades del sector.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    }
  },
  'news-tag': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/noticias/t/%{tag}/?pg=%{page}',
      TITLE: '%{tag}: Noticias y actualidad | Coches.net',
      H1: 'Noticias y actualidad de %{tag}',
      META_DESCRIPTION:
        '%{tag}: consulta la actualidad del motor y todas las noticias, comparativas, pruebas, novedades y vídeos de coches de todas las marcas y modelos, de la mano de nuestros expertos del motor.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-search': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '',
      TITLE: '%{searchTerm}: Noticias y actualidad | Coches.net',
      H1: 'Noticias y actualidad de %{searchTerm}',
      META_DESCRIPTION:
        '%{searchTerm}: consulta la actualidad del motor y todas las noticias, comparativas, pruebas, novedades y vídeos de coches de todas las marcas y modelos, de la mano de nuestros expertos del motor.',
      META_ROBOTS: 'NOINDEX, NOFOLLOW'
    }
  },
  'news-section-tips': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/consejos/',
      TITLE: 'Consejos | Coches.net',
      H1: 'Consejos',
      META_DESCRIPTION:
        'Encuentra los mejores consejos para tu coche y tu seguridad, así como consejos de compra/venta de coches, normativas...',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-section-trends': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/tendencias/',
      TITLE: 'Tendencias | Coches.net',
      H1: 'Tendencias',
      META_DESCRIPTION: 'Vídeos, reportajes, entretenimiento... Toda la actualidad del motor sin salir de casa',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-detail': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '%{path}',
      TITLE: '%{title} | Noticias coches.net',
      META_DESCRIPTION: '%{description}',
      META_ROBOTS: 'INDEX, FOLLOW',
      META_ROBOTS_EXTENDED: 'max-image-preview:large'
    }
  },
  'news-comments': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '%{path}',
      TITLE: 'Opiniones de %{title}',
      META_DESCRIPTION: 'Opiniones y comentarios sobre %{title}. Opiniones de expertos y usuarios sobre el %{title}',
      META_ROBOTS: 'INDEX, FOLLOW',
      META_ROBOTS_EXTENDED: 'max-image-preview:large'
    }
  }
}

export const technicalDetails = {
  'technical-details': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/',
      TITLE: 'Buscador de fichas técnicas | Coches.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos y versiones de todas las marcas de coches.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-comparator': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/comparador/',
      TITLE: 'Comparador de coches nuevos | Coches.net',
      META_DESCRIPTION:
        'Te ayudamos a elegir el coche para ti. Compara prestaciones y precios, entre todos los modelos actuales y descatalogados.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-comparator-results': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Comparador de coches nuevos | Coches.net',
      META_DESCRIPTION:
        'Te ayudamos a elegir el coche para ti. Compara prestaciones y precios, entre todos los modelos actuales y descatalogados.',
      META_ROBOTS: 'NOINDEX, NOFOLLOW'
    }
  },
  'technical-details-make': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/',
      TITLE: 'Fichas técnicas y precios de %{make} por modelo | Coches.net',
      META_DESCRIPTION:
        'Descubre la información técnica y precios de todos los modelos de %{make}. Encuentra en Coches.net las mejores ofertas para coches nuevos de %{make}',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-model': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/',
      TITLE: 'Fichas técnicas y precio del %{make} %{model} %{year} | Coches.net',
      META_DESCRIPTION:
        'Descubre la información técnica y precios de todas las versiones del %{make} %{model}. Encuentra en Coches.net las mejores ofertas de %{make} ',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-body-type': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/',
      TITLE: 'Fichas técnicas y precio del %{make} %{model} %{bodyType} %{year} | Coches.net',
      META_DESCRIPTION:
        'Descubre la información técnica y precios de todas las versiones del %{make} %{model} %{bodyType}. Encuentra en Coches.net las mejores ofertas de %{make} ',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-version': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/%{bodyType}/%{doors}/%{version}/%{versionId}/',
      TITLE: 'Ficha técnica y precios del %{make} %{model} %{version} %{fuelType} %{year} | Coches.net',
      META_DESCRIPTION:
        'Información y ficha técnica del %{make} %{model} %{version} %{fuelType} %{year} (Inicio de comercialización: %{initDate})',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-vehicle': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/%{bodyType}/%{doors}/%{version}/%{versionId}/',
      TITLE: 'Ficha técnica y precio del %{make} %{model} %{bodyType} %{version} %{fuelType} %{year} | Coches.net',
      META_DESCRIPTION:
        'Información y ficha técnica del %{make} %{model} %{bodyType} %{version} %{fuelType} %{year} (Inicio de comercialización: %{initDate})',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-vehicle-without-version': {
    // vehicle without version is a motos only route, covering this just for testing purposes so it's done if that route ever works for coches
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/%{vehicleId}/',
      TITLE: 'Ficha técnica y precio del %{make} %{model} %{bodyType} %{fuelType} %{year} | Coches.net',
      META_DESCRIPTION:
        'Información y ficha técnica del %{make} %{model} %{bodyType} %{fuelType} %{year} (Inicio de comercialización: %{initDate})',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-search': {
    'es-ES': {
      TITLE: 'Buscador de fichas técnicas | Coches.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos y versiones de todas las marcas de coches.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-search-results': {
    'es-ES': {
      TITLE: 'Buscador de fichas técnicas | Coches.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos y versiones de todas las marcas de coches.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const MAKES_DISTRIBUTOR_SEO = {
  'makes-distributor': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/',
      H1: 'Ofertas y precios de coches nuevos %{year}',
      TITLE: 'Precio de coches nuevos y ofertas exclusivas | Coches.net',
      META_DESCRIPTION:
        'Descubre los mejores precios de coches nuevos en coches.net y ahorra en tu próxima compra. ¡No te pierdas nuestras ofertas exclusivas!',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'makes-sizes-distributor': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/medidas/',
      H1: 'Medidas de coches nuevos',
      TITLE: 'Medidas de coches nuevos | Coches.net',
      META_DESCRIPTION:
        'Compara las medidas de coches que estas pensando en comprar y obtén las mejores ofertas del mercado en coches.net',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const MODEL_DETAIL_SEO = {
  [MODEL_DETAIL_PAGE_NAME]: {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/%{makeSlug}/%{modelSlug}/',
      H1: 'Precios %{make} %{model} nuevos',
      TITLE: 'Precios %{make} %{model} y ofertas de %{currentMonth} %{currentYear} | Coches.net',
      META_DESCRIPTION:
        'Descubre las ofertas actuales del %{make} %{model} incluyendo los precios del %{make} %{model} más actualizados del mercado. Revisa todas las características y datos técnicos junto con la opinión de nuestro equipo de expertos en Coches.net',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  [MODEL_DETAIL_INTERIOR_PAGE_NAME]: {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/interior/%{makeSlug}/%{modelSlug}/',
      H1: 'Interior del %{make} %{model}',
      TITLE: 'Interior %{make} %{model} - Detalles y Características | Coches.net',
      META_DESCRIPTION:
        'Descubre el interior del %{make} %{model}. Explora sus características, diseño y confort en coches.net. Información detallada sobre asientos, tecnología y más.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  [MODEL_DETAIL_TRUNK_PAGE_NAME]: {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/maletero/%{makeSlug}/%{modelSlug}/',
      H1: 'Maletero del %{make} %{model}',
      TITLE: 'Maletero %{make} %{model} - Detalles y Características | Coches.net',
      META_DESCRIPTION:
        'Descubre el maletero del %{make} %{model}. Explora sus características, diseño y confort en coches.net. Información detallada sobre asientos, tecnología y más.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  [MODEL_SIZES_PAGE_NAME]: {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/medidas/%{makeSlug}/%{modelSlug}/',
      H1: 'Medidas %{make} %{model}',
      TITLE: 'Medidas %{make} %{model} nuevo: Largo, ancho, alto y maletero | Coches.net',
      META_DESCRIPTION:
        'Comprueba las medidas del %{make} %{model} nuevo y compáralo con otros modelos similares en Coches.net',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const makePageSeo = {
  [DEFAULT_CULTURE]: {
    CANONICAL: '%{siteUrl}/s/%{makeSlug}/',
    TITLE: '%{make} Modelos y Precios - Toda la Gama de %{make} | Coches.net',
    META_DESCRIPTION:
      'Explora todos los modelos de %{make} disponibles. Encuentra información detallada sobre precios de %{make}, características, y más para cada vehículo %{make}.',
    H1: '%{make} Modelos y Precios',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const vehicleAppraiser = {
  'es-ES': {
    TITLE: 'Tasación de Coches Online | Tasador Gratuito | Coches.net',
    META_DESCRIPTION:
      'Calcula gratis el valor de tu coche con nuestro servicio de tasación online y descubre el precio exacto de tu vehículo. ¡Entra y prueba nuestro tasador!',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const landingFinancing = {
  'es-ES': {
    TITLE: 'Financiar un coche | Coches.net',
    META_DESCRIPTION:
      'Más del 60% de coches son financiados. Te detallamos todas las opciones disponibles para financiar tu compra, para que encuentras la mejor para ti.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const landingFormalities = {
  'es-ES': {
    TITLE: 'Trámites para comprar y vender un coche | Coches.net',
    META_DESCRIPTION:
      'Todos los trámites que necesitas conocer para la compra-venta de un coche entre particulares: requisitos, documentación y recomendaciones.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const landingFormalitiesSecurityGuidelines = {
  'es-ES': {
    TITLE: 'Compra-venta de coches segura | Coches.net',
    META_DESCRIPTION:
      'Compra y vende tu vehículo de forma segura gracias a nuestra guía. Evita las estafas más usadas en Internet tanto si eres particular como profesional.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const landingInstantOffer = {
  'es-ES': {
    H1: 'Vende tu coche a un concesionario, sin sorpresas ni preocupaciones',
    TITLE: 'Vende tu coche a un concesionario | Gratis y Seguro | Coches.net',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

// web_seller_instant_offer_landing_test
export const landingInstantOfferTest = {
  'es-ES': {
    H1: 'Vende tu coche a un profesional, sin sorpresas ni preocupaciones',
    TITLE: 'Vende tu coche a un profesional | Gratis y Seguro | Coches.net',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const instantOfferStandalone = {
  'es-ES': {
    H1: 'Vende tu coche a un comprador profesional',
    TITLE: 'Vende tu coche a un comprador profesional | Gratis y Seguro | Coches.net',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const EMPTY_SEO = {
  TITLE: '',
  META_DESCRIPTION: '',
  NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
}
export const ADS_DETAIL = {
  'ads-detail': {
    default: {
      'es-ES': {
        TITLE: '%{make} %{version} (%{year}) - %{price} € en %{province} | Coches.net',
        H1: '%{title}',
        META_DESCRIPTION:
          '%{make} %{version} del %{year}, disponible en %{province} por %{price} €. %{kms} km, %{cc} cc. Las mejores ofertas de %{bodyType} en Coches.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    offerType: {
      'es-ES': {
        TITLE: '%{make} %{version} %{offerType} - %{price} € en %{province} | Coches.net',
        H1: '%{title}',
        META_DESCRIPTION:
          '%{make} %{version} %{offerType}, disponible en %{province} por %{price} €. %{kms} km, %{cc} cc. Las mejores ofertas de %{bodyType} en Coches.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    simple: {
      'es-ES': {
        TITLE: '%{title} - %{price} € en %{province} | Coches.net',
        H1: '%{title}',
        META_DESCRIPTION: '%{title}, disponible en %{province} por %{price} €. Las mejores ofertas en Coches.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    subscription: {
      'es-ES': {
        TITLE: '%{title} - %{monthlySubscriptionFee} | Coches.net',
        H1: '%{title}',
        META_DESCRIPTION: '%{title}, por %{monthlySubscriptionFee}. Las mejores ofertas en Coches.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    }
  },
  'ads-detail-preview': {
    default: {'es-ES': EMPTY_SEO},
    offerType: {'es-ES': EMPTY_SEO},
    simple: {'es-ES': EMPTY_SEO}
  }
}

export const SPONSORED_REL_TAG = 'nofollow'

export const MAX_CHEAP_PRICE = 6000

export const DEFAULT_OPEN_GRAPH_TITLE = 'Coches.net: Coches nuevos, coches de ocasión, seminuevos, Km0'
export const DEFAULT_OPEN_GRAPH_DESCRIPTION =
  'La mejor oferta de coches de km0 y segunda mano en España: sea cual sea tu estilo de vida, tenemos un coche para ti. Coches nuevos, de segunda mano, y Km0, noticias de motor, videos y foros de coches. Compara las mejores ofertas y contacta con particulares y concesionarios. ¡Tu próximo coche está aquí!'
export const DEFAULT_OPEN_GRAPH_IMAGE = 'images/coches/icons/logo-square-rounded-512x512.png'

export const MUTABLE_PLACEHOLDERS = [
  {
    name: 'bodyType',
    mutationCases: {
      dependsOn: {},
      [BODY_TYPE_4X4_ID]: {
        literal: {
          'es-ES': 'Todoterrenos 4x4 y SUV'
        }
      },

      [BODY_TYPE_CABRIO_ID]: {
        literal: {
          'es-ES': 'Cabrio y descapotables'
        }
      }
    }
  },
  {
    name: 'type',
    mutationCases: {
      dependsOn: {
        bodyType: {
          [BODY_TYPE_4X4_ID]: ' '
        },
        categoryId: {
          [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: 'clásicos antiguos y de competición'
        }
      }
      // TODO: in MTR-56077 review if we can use something like this:
      // dependsOn: {
      //   bodyType: {
      //     [BODY_TYPE_4X4_ID]: {
      //       'es-ES': ' '
      //     }
      //   }
      // }
    }
  }
]

export const TAGCLOUD_LITERALS = {
  'es-ES': {
    SUBSCRIPTION_BODY_TYPE_SEDAN: 'berlina',
    SUBSCRIPTION_BODY_TYPE_FAMILIAR: 'familiar',
    SUBSCRIPTION_BODY_TYPE_COUPE: 'coupé',
    SUBSCRIPTION_BODY_TYPE_MINIVAN: 'monovolumen',
    SUBSCRIPTION_BODY_TYPE_4X4: 'SUV',
    SUBSCRIPTION_BODY_TYPE_CABRIO: 'cabrio y descapotables',
    SUBSCRIPTION_BODY_TYPE_PICK_UP: 'pick up',
    SUBSCRIPTION_BODY_TYPE_VANS: 'furgonetas',
    SUBSCRIPTION_CAR_OFFER_TAG_TITLE: 'ofertas renting coche',
    SUBSCRIPTION_TARGET_BUYER_PRIVATES_TAGCLOUD_TITLE: 'particulares',
    SUBSCRIPTION_TARGET_BUYER_BUSINESS_TAGCLOUD_TITLE: 'para empresas',
    SUBSCRIPTION_KEYWORD_CHEAP_TAGCLOUD_TITLE: 'baratos',
    SUBSCRIPTION_KEYWORD_BY_MONTHS_TAGCLOUD_TITLE: 'por meses',
    SUBSCRIPTION_KEYWORD_COMMITMENT_MONTHS_TAGCLOUD_TITLE: '%{commitmentMonths} meses',
    SUBSCRIPTION_KEYWORD_NO_COMMITMENT_TAGCLOUD_TITLE: 'sin permanencia',
    SUBSCRIPTION_KEYWORD_NO_ENTRY_FEE_TAGCLOUD_TITLE: 'sin entrada',
    SUBSCRIPTION_VEHICLE_TYPE_INDUSTRIALS_TAGCLOUD_TITLE: 'furgonetas',
    SUBSCRIPTION_GENERIC_OFFER_TAG_TITLE: 'ofertas renting',
    SUBSCRIPTION_BODY_TYPES_TAGCLOUD_TITLE: 'coches de renting y suscripción por carrocería',
    SUBSCRIPTION_FUEL_TYPES_TAGCLOUD_TITLE: 'coches de renting y suscripción por combustible',
    SUBSCRIPTION_FUEL_TYPES_MAKES_TAGCLOUD_TITLE: 'coches de renting y suscripción %{fuelTypeName} de la marca',
    SUBSCRIPTION_MAKES_TAGCLOUD_TITLE: 'coches de renting y suscripción de la marca',
    SUBSCRIPTION_MAKE_MODELS_TAGCLOUD_TITLE: 'modelos de %{makeName} para renting y suscripción',
    SUBSCRIPTION_VEHICLE_STATE_NEW_TAGCLOUD_TITLE: 'nuevos',
    SUBSCRIPTION_VEHICLE_STATE_USED_TAGCLOUD_TITLE: 'segunda mano',
    SUBSCRIPTION_OTHER_LINKS: 'otros enlaces de interés'
  }
}

export const SELLER_TYPES_LITERALS = {
  'es-ES': {
    [SELLER_TYPE_PROFESSIONAL]: 'PROFESIONALES',
    [SELLER_TYPE_PRIVATE]: 'PARTICULARES'
  }
}

export const DEFAULT_AREA_SERVED = {
  'es-ES': 'España'
}
